import React from 'react';
import { Box, SvgIcon, Typography } from '@mui/material';
import getMuiIcon, { IconName } from '../../../utils/getMuiIcon';
import { palette } from '../../../assets/styles/themes/tokens';
import getTextTruncationSx from '../../../utils/getTextTruncationSx';

const TEMPLATE_ICON_SIZE = 24;

const templateIconStyles = {
  color: palette.text.primary,
  width: TEMPLATE_ICON_SIZE,
  height: TEMPLATE_ICON_SIZE,
  flexShrink: 0,
};

const typographyStyles = {
  color: palette.text.primary,
  flex: '1 1 auto',
  minWidth: 0,
  ...getTextTruncationSx(1),
};

interface AiAssistantBreadcrumbProps {
  title: string;
  iconName: IconName;
  iconSx?: object;
  iconViewBox?: string;
}

const AiAssistantBreadcrumb: React.FC<AiAssistantBreadcrumbProps> = ({
  title, iconName, iconSx, iconViewBox = '0 0 24 24',
}) => (
  <>
    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      <SvgIcon
        component={getMuiIcon(iconName)}
        sx={{ ...templateIconStyles, ...iconSx }}
        viewBox={iconViewBox}
        data-testid={`svg-icon-${iconName}`}
      />
    </Box>
    <Typography data-testid='ai-assistant-breadcrumb-title' variant='body2' sx={typographyStyles}>
      {title}
    </Typography>
  </>
);

export default AiAssistantBreadcrumb;

